import { render, staticRenderFns } from "./GetnetCredentialsTab.vue?vue&type=template&id=233fac57"
import script from "./GetnetCredentialsTab.vue?vue&type=script&lang=js"
export * from "./GetnetCredentialsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports